import { useCallback, useRef, useState } from 'react';

const form = value => ({ form_schema: value.form_schema, style: value.style });
const fingerprint = value => JSON.stringify(form(value));

// Track the saved form separately from in-flight requests. A response must not
// overwrite edits made after its request was submitted.
export default function useDesignerDraft(initial) {
  const [settings, setSettings] = useState(initial);
  const [saved, setSaved] = useState(initial);
  const current = useRef(settings);
  current.current = settings;
  const load = useCallback(value => { current.current = value; setSettings(value); setSaved(value); }, []);
  const accept = useCallback((response, submitted) => {
    const changed = fingerprint(current.current) !== fingerprint(submitted);
    const next = changed ? { ...response, ...form(current.current) } : response;
    current.current = next;
    setSettings(next);
    setSaved(changed ? submitted : response);
    return !changed;
  }, []);
  const discard = () => { const next = { ...current.current, ...form(saved) }; current.current = next; setSettings(next); };
  return { settings, setSettings, load, accept, discard, dirty: fingerprint(settings) !== fingerprint(saved), current };
}
